<template>
  <div :class="$style['form-country']">
    <LazySearchDropdown
      bordered
      :items="filteredCourtries.length === 0 ? sortedCountries : filteredCourtries"
      :selected="selected"
      :searchable-data="sortedCountries.map(item => item[1])"
      @results="filteredItems => handleSearchResults(filteredItems)"
      @input="item => select(item[0])">
      <template
        v-if="selected"
        #selected>
        <img :src="`/flags/${selected.toLowerCase()}.svg`">
        {{ getCountryByCode(selected) }}
      </template>
      <template #item="{ item }">
        <img :src="`/flags/${item[0].toLowerCase()}.svg`">
        {{ item[1] }}
      </template>
    </LazySearchDropdown>
  </div>
</template>
<script setup>
import { useVuelidate } from '@vuelidate/core'
import { helpers } from '@vuelidate/validators'
const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: String,
    default: null
  }
})

const { $lang } = useNuxtApp()
const popular = ['NL', 'DE', 'BE', 'GB'] // these will appear on top in the dropdown in the order of the array
const countries = ref([])
const search = ref(null)
const filteredCourtries = ref([])
const selected = ref(null)

const isSelected = computed(() => helpers.withParams(
  { type: 'isSelected' }, () => !!selected.value
))

const rules = {
  search: {
    isSelected
  }
}

useVuelidate(rules, { search })

const select = item => {
  selected.value = item
  search.value = countries.value[selected.value]
}

const handleSearchResults = filteredItems => {
  filteredCourtries.value = filteredItems.map(item => {
    return sortedCountries.value.find(country => {
      return country[1] === item
    })
  })
}

const getCountryByCode = countryCode => {
  if (!countryCode) { return }
  return countries.value[countryCode]
}

const sortedCountries = computed(() => {
  if (!countries.value) { return }
  const sortedCountries = []
  const popularCountries = popular.map(key => [key, countries.value[key]])
  Object.keys(countries.value)
    .forEach(key => {
      if (popular.includes(key)) { return }
      sortedCountries.push([key, countries.value[key]])
    })
  return ([...popularCountries, ...sortedCountries])
})

watch(selected, () => {
  emit('update:modelValue', selected.value)
})

onMounted(() => {
  import(`../../assets/countries/${$lang}.json`).then(
    data => {
      countries.value = data.default
      if (props.modelValue) {
        selected.value = props.modelValue
        search.value = countries.value[props.modelValue]
      }
    }
  )
})
</script>
<style lang="scss" module>
.form-country {
  position: relative;

  .form-input {
    margin-bottom: 0;
  }
}
</style>
